import * as React from "react";
import clsx from "clsx";
import { Heading } from "../../typography/heading/heading.mjs";
import { Image } from "../../image/image.mjs";
import { ObjectFit } from "../../object-fit/object-fit.mjs";
import { Tooltip } from "../../tooltip/tooltip.mjs";
const ChannelButton = React.forwardRef(function ChannelButton2(props, ref) {
  const { title, image, size = "default", color, className, ...rest } = props;
  const imageProps = typeof image === "string" ? { src: image, alt: title } : image;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      ...rest,
      type: "button",
      ref,
      className: clsx(
        "channel",
        "channel--size-".concat(size),
        {
          ["channel--color-".concat(color)]: !!color
        },
        className
      )
    },
    /* @__PURE__ */ React.createElement("span", { className: "channel__image-wrapper" }, /* @__PURE__ */ React.createElement(ObjectFit, { fit: "contain", positionX: "center", positionY: "center", className: "channel__image" }, /* @__PURE__ */ React.createElement(Image, { ...imageProps, role: "img", alt: title })))
  );
});
const Channel = (props) => {
  const { title, description, meta, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Tooltip, { referenceElement: /* @__PURE__ */ React.createElement(ChannelButton, { ...rest, title }) }, /* @__PURE__ */ React.createElement("div", { className: "text" }, /* @__PURE__ */ React.createElement(Heading, { level: 1, className: "h4" }, title), description && /* @__PURE__ */ React.createElement("p", null, description), meta && meta.map((item, index) => {
    return /* @__PURE__ */ React.createElement("p", { key: index }, item.label, ": ", item.value);
  })));
};
export {
  Channel
};
